import { render, staticRenderFns } from "./OpportunitiesStages.vue?vue&type=template&id=189138b1&scoped=true&"
import script from "./OpportunitiesStages.vue?vue&type=script&lang=js&"
export * from "./OpportunitiesStages.vue?vue&type=script&lang=js&"
import style0 from "./OpportunitiesStages.vue?vue&type=style&index=0&id=189138b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189138b1",
  null
  
)

export default component.exports